export const MODULE_ID = '@fx/ngrx/loading';
export const ACTION_KEY = 'fxLoading';
export const ACTION_MESSAGE_KEY = 'fxMessage';
